import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [/* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(23.137255%,34.901961%,59.607843%)",
				fillOpacity: 1
			},
			d: "M 40 20 C 40 31.042969 31.042969 40 20 40 C 8.953125 40 0 31.042969 0 20 C 0 8.953125 8.953125 0 20 0 C 31.042969 0 40 8.953125 40 20 Z M 40 20 "
		}), /* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(100%,100%,100%)",
				fillOpacity: 1
			},
			d: "M 25.027344 20.78125 L 21.457031 20.78125 L 21.457031 33.855469 L 16.050781 33.855469 L 16.050781 20.78125 L 13.480469 20.78125 L 13.480469 16.1875 L 16.050781 16.1875 L 16.050781 13.214844 C 16.050781 11.089844 17.0625 7.757812 21.507812 7.757812 L 25.511719 7.777344 L 25.511719 12.234375 L 22.605469 12.234375 C 22.128906 12.234375 21.457031 12.472656 21.457031 13.488281 L 21.457031 16.191406 L 25.5 16.191406 Z M 25.027344 20.78125 "
		})]
	})
});
export default SvgFacebookLogo;
